export default __webpack_public_path__ + "static/media/bundle-kit.e25a8065.mp4";